import { render, staticRenderFns } from "./pay_dxsjzx.vue?vue&type=template&id=8f0ea456&scoped=true"
import script from "./pay_dxsjzx.vue?vue&type=script&lang=js"
export * from "./pay_dxsjzx.vue?vue&type=script&lang=js"
import style0 from "./pay_dxsjzx.vue?vue&type=style&index=0&id=8f0ea456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0ea456",
  null
  
)

export default component.exports